module.exports = __webpack_public_path__ + "img/2.2_Chief-Investigators_2_Wilson.764f70a5c8bf6c28477de2d272a58936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.2_Chief-Investigators_2_Wilson.png
// module id = 749
// module chunks = 0